import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {StaticQuery, graphql} from 'gatsby';
import he from 'he';

const SEO = function ({description, lang, meta, keywords, title, ogimage}) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description;
        return (
          <Helmet
            htmlAttributes={{lang}}
            title={he.decode(title)}
            titleTemplate={
              title === 'Sâmia Bomfim'
                ? `%s, deputada federal do PSOL`
                : `%s | ${data.site.siteMetadata.title}`
            }
            meta={[
              {
                name: 'description',
                property: 'og:description',
                content: he.decode(metaDescription),
              },
              {
                property: 'og:title',
                content:
                  title === 'Sâmia Bomfim'
                    ? 'Sâmia Bomfim, deputada federal do PSOL'
                    : he.decode(title),
              },
              {
                property: 'og:type',
                content: 'website',
              },
              {
                name: 'twitter:card',
                content: 'summary',
              },
              {
                name: 'twitter:creator',
                content: data.site.siteMetadata.author,
              },
              {
                name: 'twitter:title',
                content:
                  title === 'Sâmia Bomfim'
                    ? 'Sâmia Bomfim, deputada federal do PSOL'
                    : title,
              },
              {
                name: 'twitter:description',
                content: he.decode(metaDescription),
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: 'keywords',
                      content: keywords.join(', '),
                    }
                  : []
              )
              .concat(
                ogimage
                  ? [
                      {
                        property: 'og:image',
                        content: ogimage.src.startsWith('http')
                          ? ogimage.src
                          : `https://samiabomfim.com.br${ogimage.src}`,
                      },
                      {
                        property: 'og:image:width',
                        content: ogimage.width,
                      },
                      {
                        property: 'og:image:height',
                        content: ogimage.height,
                      },
                    ]
                  : [
                      {
                        property: 'og:image',
                        content: `https://samiabomfim.com.br${data.pic.childImageSharp.fixed.src}`,
                      },
                      {
                        property: 'og:image:width',
                        content: data.pic.childImageSharp.fixed.width,
                      },
                      {
                        property: 'og:image:height',
                        content: data.pic.childImageSharp.fixed.height,
                      },
                    ]
              )
              .concat(meta)}
          />
        );
      }}
    />
  );
};

SEO.defaultProps = {
  lang: 'pt',
  meta: [],
  keywords: [],
  ogimage: null,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  ogimage: PropTypes.object,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }

    pic: file(relativePath: {eq: "bg-hero.jpg"}) {
      childImageSharp {
        fixed(width: 1200, height: 630) {
          src
          width
          height
        }
      }
    }
  }
`;
